import script from "./AddGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGroup.vue?vue&type=script&setup=true&lang=js"

import "./AddGroup.vue?vue&type=style&index=0&id=6eb05514&lang=scss"

const __exports__ = script;

export default __exports__